var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgIconDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    rx: 23,
    fill: "#F3F5FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 18.2C12.5 15.052 15.052 12.5 18.2 12.5H27.8C30.948 12.5 33.5 15.052 33.5 18.2V27.8C33.5 30.948 30.948 33.5 27.8 33.5H18.2C15.052 33.5 12.5 30.948 12.5 27.8V18.2ZM18.2 14.3C16.0461 14.3 14.3 16.0461 14.3 18.2V27.8C14.3 29.9539 16.0461 31.7 18.2 31.7H27.8C29.9539 31.7 31.7 29.9539 31.7 27.8V18.2C31.7 16.0461 29.9539 14.3 27.8 14.3H18.2Z",
    fill: "#121314"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1 17.9001C18.4372 17.9001 17.9 18.4374 17.9 19.1001C17.9 19.7628 18.4372 20.3001 19.1 20.3001C19.7627 20.3001 20.3 19.7628 20.3 19.1001C20.3 18.4374 19.7627 17.9001 19.1 17.9001ZM16.1 19.1001C16.1 17.4432 17.4431 16.1001 19.1 16.1001C20.7568 16.1001 22.1 17.4432 22.1 19.1001C22.1 20.757 20.7568 22.1001 19.1 22.1001C17.4431 22.1001 16.1 20.757 16.1 19.1001Z",
    fill: "#121314"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.0198 23.5656C28.4098 22.803 27.2452 22.8175 26.6543 23.595L24.1419 26.9008C23.1096 28.259 21.2123 28.6066 19.7656 27.7024L18.442 26.8752C17.8497 26.505 17.0803 26.5926 16.5864 27.0865L14.0364 29.6365L12.7636 28.3637L15.3136 25.8137C16.4002 24.7271 18.0929 24.5344 19.396 25.3488L20.7196 26.176C21.3772 26.587 22.2396 26.429 22.7088 25.8116L25.2212 22.5059C26.5212 20.7953 29.0832 20.7634 30.4254 22.4411L33.3028 26.0379L31.8972 27.1623L29.0198 23.5656Z",
    fill: "#121314"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgIconDark);
export default __webpack_public_path__ + "static/media/img-icon-dark.24c8f555185f8fcada500f02087d586d.svg";
export { ForwardRef as ReactComponent };